export const resumeData = {
  name: 'Nithin Sai Jampala',
  headline: 'SDE @ KoKo AI · Gitam ’25',
  location: 'Hyderabad, Telangana, India',
  contact: {
    city: 'Hyderabad',
    phone: '9573757096',
    email: 'nithinsai2603@gmail.com',
    linkedin: 'linkedin.com/in/nithinjampala',
    portfolio: 'nithinchoudary.in'
  },
  topSkills: ['Cybersecurity', 'MERN Stack', 'Artificial Intelligence (AI)'],
  certifications: [
    'Introduction to Hyperledger Blockchain Technologies LFS171',
    'Python Data Structures',
    'C for Everyone',
    'CSS',
    'Pre Security'
  ],
  publications: [
    'Predictive Facility Utilization Analysis for Airports using IoT and Machine Learning'
  ],
  summary:
    'Software Development Engineer at Koko AI, working across AI, MERN stack, cloud, cybersecurity, prompting, and quality testing. Bachelor of Technology in Computer Science at GITAM Deemed University. Driven by impactful projects, premium product craft, and deepening expertise in cybersecurity to solve real problems through software.',
  experience: [
    {
      company: 'Koko AI',
      span: '5 months',
      roles: [
        {
          title: 'SDE',
          period: 'April 2026 — Present · 2 mos',
          location: 'Hyderabad',
          stack: ['MERN', 'AI', 'Cloud', 'Prompting', 'QA & Testing', 'Cybersecurity', 'UI / UX']
        },
        {
          title: 'AI Software Engineer',
          period: 'January 2026 — April 2026 · 4 mos',
          location: 'Hyderabad',
          stack: ['MERN', 'AI', 'Cloud', 'Prompting', 'QA & Testing', 'Cybersecurity', 'UI / UX']
        }
      ]
    },
    {
      company: 'InterviewBuddy™',
      span: '9 months',
      roles: [
        {
          title: 'Community Lead',
          period: 'February 2025 — May 2025 · 4 mos',
          location: 'India'
        },
        {
          title: 'Community Volunteer',
          period: 'September 2024 — February 2025 · 6 mos',
          location: 'Visakhapatnam, AP, India'
        }
      ]
    },
    {
      company: 'Online Blood Donors Association',
      span: '1 year',
      roles: [
        {
          title: 'Web Developer & Designer',
          period: 'June 2024 — May 2025 · 1 yr',
          location: 'India',
          note: 'Built a platform that facilitates blood donation — a fulfilling, impact-led project.'
        }
      ]
    },
    {
      company: 'The African Wave',
      span: '3 months',
      roles: [
        {
          title: 'Project Lead Developer',
          period: 'January 2025 — March 2025 · 3 mos'
        }
      ]
    },
    {
      company: 'Pioneers Club',
      span: '9 months',
      roles: [
        {
          title: 'Core Member · Design',
          period: 'August 2023 — April 2024 · 9 mos',
          location: 'Visakhapatnam, AP, India'
        }
      ]
    }
  ],
  education: [
    {
      school: 'GITAM Deemed University',
      degree: 'B.Tech, Computer Science',
      period: 'October 2021 — June 2025'
    },
    {
      school: 'Sri Chaitanya College of Education',
      degree: '12th · MPC',
      period: 'June 2019 — April 2021'
    },
    {
      school: 'Sri Chandra Techno School',
      degree: 'High School',
      period: 'March 2019'
    }
  ]
};
